import api from "@/common/js/api";
import { ElMessageBox } from "element-plus";
export default {
  namespaced: true,
  state: () => ({
    $vm: null,
  }),
  mutations: {
    setVm: (state, vm) => {
      state.$vm = vm;
    },
  },
  getters: {
    showComponentCTBA: (state) => {
      if (state.$vm) {
        // console.log(state.$vm.showComponent);
        return state.$vm.showComponent;
      } else {
        return false;
      }
    },
  },
  actions: {
    reportToCTBA($store, formData) {
      return new Promise((resolve, reject) => {
        let ajaxObj = null
        if(__type__ === 'water') {
          ajaxObj = api.form("/Signture/GetHtmlSignUrl", formData)
        } else {
          ajaxObj = api.form(`/Signture/GetHtmlSignUrl${location.search}`, {
            key: formData.key,
            caExtraData: formData.caExtraData
          })
        }
        ajaxObj.then((res) => {
          if (res.result) {
            resolve(res);
          } else {
            ElMessageBox({
              type: "error",
              title: "报错提示",
              message: res.msg || "接口报错",
              showCancelButton: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            });
          }
        });
      });
    },
    getAttachInfo($store, formData) {
      return new Promise((resolve, reject) => {
        api.get("/Signture/GetAttachInfo", formData).then((res) => {
          if (res.result) {
            resolve(res);
          } else {
            // ElMessageBox({
            //   type: "error",
            //   title: "报错提示",
            //   message: res.msg || "接口报错",
            //   showCancelButton: true,
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            // });
          }
        });
      });
    },
  },
};
